export const handleErrorState = (state: any, action: any) => {
  state.loading = false
  state.error = {
    type: action.type,
    name: action?.error?.name ?? action.type,
    message: action.type,
  }
}
